import React from 'react'
import Overlay from '../Overlay'
import { useSelector } from 'react-redux'
import { setShowNotifications } from '../../redux/auth/actions'

const styles = {
    container: {
        width: 600,
        maxHeight: '85vh',
        overflow: 'auto',
        padding: '2em',
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '0.64em',
    },
    body: {
        marginTop: '0.64em',
    },
    footer: {
        marginTop: '1em',
    },
    section: {
        marginTop: '0.64em',
        display: 'flex',
        justifyContent: 'space-between',
    },
    column: {
        width: 260,
    },
}


const Notifications = () => {

    const visible = useSelector((state) => state.auth.showNotifications)

    const handleClose = () => {
        setShowNotifications(false)
    }

    return (
        <Overlay
            onClose={handleClose}
            visible={visible}
            minimal={false}
            headerText={"Notifications"}
            closebutton={true}
        // background="#EAF8FF"
        >
            <div style={styles.container}>
                <div style={{ marginBottom: '1em' }}>
                    No current maintenance or system updates planned.
                </div>
                <div style={{ marginBottom: '1em' }}>
                    Stay tuned for announcements of future product releases.
                </div>
                <div style={styles.footer}>
                    Questions or comments? Contact BSS Support at <a href="mailto:support@bssnet.com">support@bssnet.com</a> or <a href="tel:8003155676">(800) 315-5676</a>
                </div>

            </div>
        </Overlay >
    )
}

export default Notifications